<template>
  <div class="health-forecast-header">
    <div class="health-forecast-header-labels">
      <h1 class="health-forecast-header-title">{{ headerTitle }}</h1>
      <span class="health-forecast-header-subtitle">{{ headerSubtitle }}</span>
    </div>
    <div class="health-forecast-header-picture">
      <slot name="image" />
      <div
        v-if="stoererActive === 'true'"
        class="health-forecast-header-picture-stoerer"
      >
        <div class="stoerer">
          <a
            v-if="showHeaderLink === 'true'"
            class="stoerer-circle"
            :href="headerLink"
            :target="headerLinkTarget"
          >
            <p v-html="headerLinkStoererTitle"></p>
          </a>
          <div v-else class="stoerer-circle">
            <p v-html="headerLinkStoererTitle"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthForecastHeader',
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerSubtitle: {
      type: String,
      default: () => '',
    },
    imageSrcSet: {
      type: [String, undefined],
      required: true,
    },
    headerLinkStoererTitle: {
      type: String,
      default: '',
    },
    headerLink: {
      type: String,
      default: '',
    },
    headerLinkTarget: {
      type: String,
      default: '',
    },
    showHeaderLink: {
      type: String,
      default: 'false',
    },
    stoererActive: {
      type: String,
      default: 'false',
    },
  },
}
</script>

<style lang="postcss">
.health-forecast-header {
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  padding: 124px 40px 0;

  &-picture {
    position: relative;
    margin-right: 0;

    &-stoerer {
      position: absolute;
      top: -60.5px;
      right: -60.5px;

      .stoerer {
        width: 100%;
        max-width: 1000px;
        height: 135px;
        position: relative;
        margin: auto;
        text-decoration: none;
        transform: rotate(11deg);

        &:hover {
          text-decoration: none;
          border-bottom: 0;
        }

        &-circle {
          width: 135px;
          height: 100%;
          background-color: var(--c-secondary-color-1);
          border-radius: 50%;
          display: flex;
          align-items: center;

          &:hover {
            border-bottom: none;
          }

          p {
            color: var(--c-primary-neutral-3);
            width: 100%;
            font-size: 18px;
            font-weight: bold;
            font-style: normal;
            line-height: 1.11;
            letter-spacing: 0.22px;
            margin: auto 12px;
            text-align: center;
          }
        }
      }
    }
  }

  &-labels {
    margin-left: auto;
    margin-right: 45px;
    width: 546px;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-title {
    z-index: 10;
    font-family: 'Faustina', serif;
    font-size: 60px;
    font-weight: bold;
    font-style: normal;
    line-height: 1;
    text-align: center;
    color: var(--c-primary-neutral-3);
    width: 100%;
  }

  &-subtitle {
    margin-top: 20px;
    z-index: 10;
    display: block;
    font-size: 25px;
    font-weight: normal;
    font-style: normal;
    line-height: 1.72;
    letter-spacing: 0.3px;
    text-align: center;
    color: var(--c-primary-neutral-3);
    width: 100%;
  }
}

@media (max-width: 1360px) {
  .health-forecast-header {
    max-width: 1000px;
    padding: 124px 0 0 0;

    &-labels {
      margin-right: 20px;
    }
  }
}

@media (max-width: 1160px) {
  .health-forecast-header {
    max-width: 860px;
    flex-direction: column;
    padding: 40px 0 0 0;

    &-labels {
      margin-right: 0;
      margin-bottom: 58px;
      width: 280px;
    }

    &-title {
      font-size: 30px;
    }

    &-subtitle {
      display: none;
    }

    &-picture {
      &-stoerer {
        right: 0;
        top: -40px;

        .stoerer {
          height: 80px;

          &-circle {
            width: 80px;

            p {
              font-size: 12px;
              margin: auto 4px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 860px) {
  .health-forecast-header {
    padding: 20px 40px;

    &-labels {
      width: 177px;
      margin-bottom: 20px;
    }

    &-title {
      font-size: 19px;
    }

    &-picture-stoerer {
      right: 16px;
      top: -15px;

      .stoerer {
        height: 52px;

        &-circle {
          width: 52px;

          p {
            font-size: 7px;
          }
        }
      }
    }
  }
}

@media (max-width: 544px) {
  .sanitasHealthForecastOverview {
    .header-image-cover {
      transform: scale(1.25);
      top: 45px;
    }

    .health-forecast-header {
      padding: 18px 30px 0 0;
    }
  }
}
</style>
